import { useState } from "react";
import { Field, Honeypot, SubmitButton, SuccessBlock, useSubmit, inputCls, selectCls, validPhone, validEmail } from "./fields";
import { toast } from "sonner";

const INIT = { full_name: "", phone: "", email: "", college_name: "", qualification: "", course: "", year_of_passing: "", program: "", preferred_location: "", message: "", website: "" };

export default function InternshipForm() {
  const [f, setF] = useState(INIT);
  const { submit, loading, success, setSuccess } = useSubmit("/internship-applications", "Internship application received. Our team will contact you shortly.");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validPhone(f.phone)) return toast.error("Please enter a valid phone number.");
    if (!validEmail(f.email)) return toast.error("Please enter a valid email address.");
    const ok = await submit(f);
    if (ok) setF(INIT);
  };

  if (success)
    return <SuccessBlock testId="internship-form-success" message="Thank you. Your internship application has been received. Our team will contact you shortly." contactEmail="career@maqlinesolutions.com" onReset={() => setSuccess(false)} />;

  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="internship-form">
      <Honeypot value={f.website} onChange={set("website")} />
      <Field label="Full Name" required><input data-testid="if-name" className={inputCls + " w-full"} value={f.full_name} onChange={set("full_name")} required /></Field>
      <Field label="Phone" required><input data-testid="if-phone" className={inputCls + " w-full"} value={f.phone} onChange={set("phone")} required placeholder="+91" /></Field>
      <Field label="Email" required><input data-testid="if-email" type="email" className={inputCls + " w-full"} value={f.email} onChange={set("email")} required /></Field>
      <Field label="College / Institution"><input className={inputCls + " w-full"} value={f.college_name} onChange={set("college_name")} /></Field>
      <Field label="Qualification" required>
        <select data-testid="if-qualification" className={selectCls} value={f.qualification} onChange={set("qualification")} required>
          <option value="">Select</option>
          <option>B.Tech</option><option>Diploma</option><option>ITI</option><option>Other</option>
        </select>
      </Field>
      <Field label="Course / Branch"><input className={inputCls + " w-full"} value={f.course} onChange={set("course")} placeholder="e.g. Mechanical, EEE, Fitter" /></Field>
      <Field label="Year of Passing"><input className={inputCls + " w-full"} value={f.year_of_passing} onChange={set("year_of_passing")} placeholder="e.g. 2026" /></Field>
      <Field label="Preferred Program" required>
        <select data-testid="if-program" className={selectCls} value={f.program} onChange={set("program")} required>
          <option value="">Select program</option>
          {["Industrial Internship", "Industrial Training", "Online Internship", "Technical Exposure", "Manufacturing Exposure"].map((p) => <option key={p}>{p}</option>)}
        </select>
      </Field>
      <Field label="Preferred Location"><input className={inputCls + " w-full"} value={f.preferred_location} onChange={set("preferred_location")} /></Field>
      <Field label="Message" className="sm:col-span-2"><textarea className={inputCls + " w-full h-20 py-2.5"} value={f.message} onChange={set("message")} /></Field>
      <div className="sm:col-span-2">
        <SubmitButton loading={loading} testId="internship-form-submit">Apply for Internship</SubmitButton>
      </div>
    </form>
  );
}
